import React from "react";
import formModelStore from "@lib/store/FormModelStore";
import IconSave from "@lib/components/icons/IconSave";
import Button from "@lib/components/common/Button";
import CustomerStore from "@lib/store/customerStore";
import GenerateDocumentationModal from "./calculation-printouts/GenerateDocumentationModal";
import buildResourcePath from "@lib/buildResourcePath";

interface SelfProps {
    calculationName: string,
    saveCalculation: () => void,
    hasDocumentationPermission: boolean,
    showPrintButton: boolean,
    showSaveButton: boolean,
    calculationId: any,
    project: any,
}

interface SelfState {
    calculationName: string,
    editName: boolean,
    documentationsModalIsOpen: boolean,
    documentationModalIsOpen: boolean
}

export default class TWSProjectCalculationPageHeader extends React.Component<SelfProps, SelfState> {
    state = {
        calculationName: this.props.calculationName?.length > 0 ? this.props.calculationName : __("New calculation"),
        editName: false,
        documentationsModalIsOpen: false,
        documentationModalIsOpen: false
    }

    constructor(props: SelfProps) {
        super(props);

        formModelStore.formModel.name.value = this.state.calculationName;
    }

    getActions = () => {
        let actions = [];

        actions.push({
            label: __('Save'),
            className: "button-save",
            icon: IconSave,
            theme: Button.Theme.BorderOnly,
            disabled: !CustomerStore.canSave() || !this.props.showSaveButton,
            onClick: this.props.saveCalculation,
        });
        return actions;
    }


    render() {
        return (
            <div>
                <div className="btn-go-back" style={{ paddingTop: '20px' }}>
                    <span>&#x2190;</span>
                    <a className="btn-show-all" href={buildResourcePath(`/TWSProject/Edit/${this.props.project.id.value}`)}> {`${__('Go back to')} ${this.props.project.number.value}`}</a>
                </div>

                <div className="page-body-titlebar-wrap">
                    <div className="page-body-titlebar">

                        <h3 className="page-body-title">
                            {!this.state.editName && (
                                <>
                                    <span>{this.state.calculationName}</span>
                                    <div className={`name-edit-button`} onClick={() => {
                                        this.setState({ editName: true })
                                    }}>

                                        <svg viewBox="0 0 512 512" width="12px" height="12px" style={{ cursor: 'pointer' }}>
                                            <g>
                                                <path
                                                    d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981   c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611   C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069   L27.473,390.597L0.3,512.69z"
                                                    fill="#9DA4B3" />
                                            </g>
                                        </svg>
                                    </div>
                                </>
                            )}
                            {this.state.editName && (
                                <>
                                    <input type={`text`} value={this.state.calculationName} onChange={e => this.changeName(e)} />
                                    <div className={`name-edit-button`} onClick={() => {
                                        this.updateName()
                                    }}>
                                        <svg viewBox="0 0 612 612" width="12px" height="12px" style={{ cursor: 'pointer' }}>
                                            <g>
                                                <polygon
                                                    points="573.75,0 183.485,516.968 37.657,380.702 0,422.548 189.452,612 612,38.843"
                                                    fill="#9DA4B3" />
                                            </g>
                                        </svg>

                                    </div>
                                </>
                            )}

                        </h3>
                        <div className="page-body-action-buttons">
                            <div className="desktop-only">
                                {this.getActions().map((action, idx) => (
                                    <Button key={idx} disabled={action.disabled} icon={action.icon} theme={action.theme}
                                        className={action.className}
                                        onClick={action.onClick}>{action.label}</Button>
                                ))}
                            </div>
                            {this.props.showPrintButton && <div className="mass-export-dropdown">
                                {this.props.hasDocumentationPermission && this.renderDocumentationDropdown()}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    updateName = () => {
        formModelStore.formModel.name.value = this.state.calculationName;
        this.setState({ editName: false })
    }

    private changeName(e: React.ChangeEvent<HTMLInputElement>) {
        let value = e.target.value;
        if (value.length < 1) {
            value = __("New calculation");
        }
        this.setState({
            calculationName: value
        })
    }

    renderDocumentationDropdown(): React.ReactNode {
        return (
            <React.Fragment>
                <GenerateDocumentationModal
                    id={this.props.calculationId.value}
                    isOpen={this.state.documentationModalIsOpen}
                    onClose={() => {
                        this.setState({ documentationModalIsOpen: false });
                    }}
                />
                <span className="desktop-only">
                    <Button onClick={() => this.setState({ documentationModalIsOpen: true })}>
                        {__("Generate documentation")}
                    </Button>
                </span>
            </React.Fragment>
        );
    }
}